import { ImageModelAlto } from './alto.model';
import { ParseAdapter } from "../abstract/ParseAdapter";
import { Damage } from "./damage.model";

export class TchekImageUrl {
    mini: string;
    hd: string;
    camera: number;
    picture: number;
    image: string;

    constructor(opts?: {
        hd?: string,
        mini?: string,
        camera?: number,
        picture?: number,
        image?: string
    }) {
        this.hd = (opts && opts.hd) || '';
        this.mini = (opts && opts.mini) || '';
        this.camera = (opts && opts.camera) || -1;
        this.picture = (opts && opts.picture) || -1;
        this.image = (opts && opts.image) || undefined;
    }
}

export class TchekImageChild extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }


    get name(): string { return this.parseObject.get('name'); }
    set name(value: string) { this.parseObject.set('name', value); }


    get file(): Parse.File { return this.parseObject.get('file') }
    set file(value: Parse.File) { this.parseObject.set('file', value); }

    get isDeleted(): boolean { return this.parseObject.get('isDeleted') }
    set isDeleted(value: boolean) { this.parseObject.set('isDeleted', value); }

    get classification(): boolean { return this.parseObject.get('classification') }
    set classification(value: boolean) { this.parseObject.set('classification', value); }

    get userPtr(): Parse.User { return this.parseObject.get('userPtr'); }
    set userPtr(value: Parse.User) { this.parseObject.set('userPtr', value); }

    get tchekPtr(): any { return this.parseObject.get('tchekPtr') }
    set tchekPtr(value: any) { this.parseObject.set('tchekPtr', value); }

    get size(): { width: number, height: number } { return this.parseObject.get('size'); }
    set size(value: { width: number, height: number }) { this.parseObject.set('size', value); }

    get damagePtr(): Damage { return this.parseObject.get('damagePtr') }
    set damagePtr(value: Damage) { this.parseObject.set('damagePtr', value); }

    get detectionModel(): string { return this.parseObject.get('detectionModel') }
    set detectionModel(value: string) { this.parseObject.set('detectionModel', value); }

    get altoPtr(): ImageModelAlto { return this.parseObject.get('altoPtr') }
    set altoPtr(value: ImageModelAlto) { this.parseObject.set('altoPtr', value); }

    get isInterior(): boolean { return this.parseObject.get('isInterior') }
    set isInterior(value: boolean) { this.parseObject.set('isInterior', value); }

}



export class TchekImageNoChild extends TchekImageChild {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get parentPtr(): TchekImageChild {
        if (this.parseObject.get('parentPtr')) return new TchekImageChild(this.parseObject.get('parentPtr'))
        else return undefined
    }
    set parentPtr(value: TchekImageChild) { this.parseObject.set('parentPtr', value); }

}

export class TchekImage extends TchekImageNoChild {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }
    child: TchekImage = undefined
}


// WEBPACK FOOTER //
// ./src/app/model/image.ts